 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		396: 0,
 		279: 0,
 		280: 0,
 		290: 0,
 		338: 0,
 		339: 0,
 		347: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~e39eff3e","1":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~19435117","2":"vendors~AddClosedAlertIDUseCase~CurrentUserUseCase~GetAreasCourseUseCase~GetCartCourseUseCase~GetCat~cc70658c","3":"vendors~SendHeaderTrackingUseCase~SendPlayerTrackingUseCase~SendTrackingUseCase","4":"INTERNAL","216":"AddClosedAlertIDUseCase","217":"CreateDeviceUseCase","218":"CreateDomestikaFollowUseCase","219":"CreateJWTUserUseCase","220":"CreateUserLiveSessionUseCase","221":"CurrentUserUseCase","222":"CurrentWithoutRelationshipsUserUseCase","223":"DeleteDeviceUseCase","224":"DeleteFollowUseCase","225":"ENV_CONFIG1","226":"ENV_CONFIG4","227":"ENV_CONFIG5","228":"ENV_CONFIG6","229":"ENV_CONFIG7","230":"FinishUserLiveSessionUseCase","231":"GetAccessTokenUserUseCase","232":"GetAdvanceGDPRStatusUserUseCase","233":"GetAllBlogUseCase","234":"GetAreasCourseUseCase","235":"GetCartCourseUseCase","236":"GetCategoriesCourseUseCase","237":"GetCourseUseCase","238":"GetFinalProjectVideoByCourseIDCourseUseCase","239":"GetGDPRStatusUserUseCase","240":"GetListLiveFeedbackQuestionUseCase","241":"GetListLiveSessionUseCase","242":"GetListLiveStreamUseCase","243":"GetLiveChannelUseCase","244":"GetLiveSessionUseCase","245":"GetOrganizationUseCase","246":"GetPlusPromotionUseCase","247":"GetPostContentBlogUseCase","248":"GetPromotionCodeAlertUseCase","249":"GetPromotionUseCase","250":"GetPubnubCredentialsUseCase","251":"GetSessionDataUserUseCase","252":"GetSimpleUserUseCase","253":"GetSoftwaresCourseUseCase","254":"GetUserAlertUseCase","255":"GetVideoProgressListCourseUseCase","256":"GetVideoSpeedUserUseCase","257":"GetVideoVolumeUserUseCase","258":"LogoutUserUseCase","259":"PathToRegexp","260":"RefreshAccessTokenUserUseCase","261":"RemoveAccessTokenUserUseCase","262":"SearchCourseUseCase","263":"SendHeaderTrackingUseCase","264":"SendLiveFeedbackAnswersUseCase","265":"SendPlayerTrackingUseCase","266":"SendTrackingUseCase","267":"SendVideoProgressCourseUseCase","268":"SetAdvanceGDPRStatusUserUseCase","269":"SetGDPRStatusUserUseCase","270":"SetVideoSpeedUserUseCase","271":"SetVideoVolumeUserUseCase","272":"UpdateLanguageUserUseCase","273":"UpdateLiveSessionUseCase","274":"UpdateVideoAudioAndSubtitlesCourseUseCase","275":"UpdateVideoProgressCourseUseCase","276":"ViewPageTrackingUseCase","346":"vendors~AddClosedAlertIDUseCase","347":"vendors~AmplitudeJS","348":"vendors~SearchCourseUseCase","349":"vendors~ViewPageTrackingUseCase"}[chunkId]||chunkId) + "-" + {"0":"3abbed6f42bfb2789afa","1":"f51fcc51a2d648427b8a","2":"f4cceebea759d18cd914","3":"19eb19c7661952d13f4c","4":"17c221a11f5d2f7efe63","5":"79fd81eb883bf1258127","215":"378e0c747a31991c2547","216":"ecc7ad8f0a89051ca5dc","217":"2acf69792cd1886b43db","218":"e8e9c96797da0cc7e6a9","219":"b1771b5f77550d281832","220":"fbe23c06faf4ef14874c","221":"515e326a6c681eb78ba3","222":"8008e3d2b286798f8c95","223":"1cec8675faa917e2297b","224":"2ff4162d595b02c90a6e","225":"c8a20aaf3a4dbdbf7f0c","226":"7842bc88e18f06e562c7","227":"d32b783b80eef750c9c3","228":"97e37e8489ce66611e96","229":"b641134b420fc9e30978","230":"fef243b13bfc1508a46a","231":"fd7e03187bf42fd97c3d","232":"454ab1d0e9345956ff5b","233":"48817db9c685c8390d54","234":"e56af4e634587aa9f471","235":"ba58f982faa73476ddd3","236":"7dfe263befb817099ef4","237":"86030c98d849915de4b3","238":"a2ae8496b26826b4c6cb","239":"b03f22b34215cb7bcc29","240":"fe23e2a913af124af786","241":"471a080834c84c324e8d","242":"1ab7a1a402c562d707dd","243":"6c96b5343767688b10fd","244":"3fefc183b1e72ee0e640","245":"aca4dc59f002ede5c2ac","246":"45dd310014d66c72db69","247":"c58186a49ec2e4a4a6ba","248":"2bc58f15ca9ed890741b","249":"2677e0988fc1c11e6389","250":"38dad7d52519342ce97c","251":"82b399e04aada89237af","252":"52e427276b97869ea972","253":"c6e0aac5833e9565883b","254":"610ccde8b0d243457227","255":"bc4b25270556d376522c","256":"8cd4a1c4bf74fe29a9ea","257":"550a4f687ebdf8352d16","258":"b0d103f4251c6708b145","259":"199fbd31e91c447f4f18","260":"a57a1d8e4ecc5e9fd64e","261":"663627f4cfadeb0ca65c","262":"af020995ef8c068ce3e9","263":"f2e1b13f8191d642b687","264":"a099cfecde33454f0edf","265":"0a5602b9ab5e8cdb6fa5","266":"dfcded9f2d8263b341c4","267":"3555be2ecdc2afd5b7d5","268":"08aee540e9c43b1f19d6","269":"0279d4e81708fd592dcb","270":"997e254877bffd69db6e","271":"bcefc3f5c5e83726881a","272":"11d861e89abb131596a2","273":"0e7de2e900f9d9691387","274":"151c71f3d7c99b6f15ed","275":"c8dc6f03d39d06f172e4","276":"889da3f8f61690a9d48b","346":"a43dbd3e614a7e79c4c8","347":"40832aa54010d312c2a0","348":"5f869ce7c62cb5fb7b27","349":"2f46d71dfb55a45a7ca5","417":"fa8e0a1a55c1b9a89ec9","419":"485ee72565cda5bdfd13","420":"9dbd7825dfc6aa251cf2","638":"1c21b3448b7146abf8b5","639":"9e8c4fe2399bd1f26776","640":"9576654aae9163bec6a7","652":"001ee72459e9b5afeece"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.domestika.org/raw/upload/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2196);
